var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import dayjs from 'dayjs';
import * as msg from '@lean-body/src/messages';
import { useState, useEffect } from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { ArrowDirection, ArrowIcon, CalendarSolidIcon, CheckIcon, InputWithoutOutline } from '../atoms';
import { Course, } from '@lean-body/src/domain';
import { DateSelectFormWithoutOutline, GoalMatchingAssessmentFormDailyGoals, GoalMatchingAssessmentFormFooter, GoalMatchingAssessmentFormMessage, TimeSelectForm, TimeSelectFormat, } from '../molecules';
import { validateDate } from '@lean-body/src/util';
import { CourseTimeInfo } from './course_time_info';
import { GOAL_MATCHING_ASSESSMENT_VERSION } from '../pages/main_goal_matching_assessment';
import { GoalMatchingAssessmentHeader } from '../molecules/goal_matching_assessment_header';
import { CircleCheckPink } from '../atoms/icons/circle_check_pink';
export const GoalMatchingAssessmentForm = ({ apiClient, config, index, progressCurrent, progressQuestionCount, matchingAssessment, pastAnswers, currentAnswers, activityLevel, gender, birthday, currentWeight, currentHeight, weightGoal, weightGoalPaceId, onClickNext, onClickBack, showProgress, }) => {
    const choices = matchingAssessment.matchingAssessmentChoices;
    const isChoiceQuestion = choices.length !== 0;
    const textField = matchingAssessment.matchingAssessmentTextField;
    const [textValue, setTextValue] = useState('');
    const [dateValue, setDateValue] = useState('');
    const [messageTitle, setMessageTitle] = useState('');
    const [messageBody, setMessageBody] = useState('');
    const [currentChoices, setCurrentChoices] = useState([]);
    const [goalDate, setGoalDate] = useState();
    const [dailyGoals, setDailyGoals] = useState([]);
    const isDisabled = matchingAssessment.isKindInterestingLesson
        ? currentChoices.length < 3
        : isChoiceQuestion
            ? currentChoices.length === 0
            : textField.isInputTypeDate
                ? !dateValue
                : !textValue;
    const answer = pastAnswers.find((v) => v.matchingAssessmentId === matchingAssessment.id);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (isChoiceQuestion) {
            if (matchingAssessment.isKindWeightGoalPace) {
                // 減量ペース設定
                if (currentWeight > weightGoal) {
                    apiClient.fetchWeightGoalPace(currentWeight, weightGoal, GOAL_MATCHING_ASSESSMENT_VERSION).then((values) => {
                        choices.forEach((choice) => {
                            values.forEach((v) => {
                                if (choice.id === v.choiceId) {
                                    choice.description = v.description;
                                    choice.goalDate = v.goalDate;
                                }
                            });
                        });
                        setDefaultCurrentChoices();
                    });
                }
            }
            else if (matchingAssessment.isKindWeightGoalApproach) {
                // 減量アプローチ設定
                apiClient
                    .fetchWeightGoalApproach(activityLevel, gender, birthday, currentHeight, currentWeight, weightGoal, weightGoalPaceId, GOAL_MATCHING_ASSESSMENT_VERSION)
                    .then((values) => {
                    choices.forEach((choice) => {
                        values.forEach((v) => {
                            if (choice.id === v.choiceId)
                                choice.dailyGoals = v.dailyGoals;
                        });
                    });
                    setDefaultCurrentChoices();
                });
            }
            else {
                setDefaultCurrentChoices();
            }
        }
        else if (textField.isInputTypeDate) {
            // 今回の回答 -> 過去の回答 -> 未回答 の順番で設定する
            if ((_a = currentAnswers[index]) === null || _a === void 0 ? void 0 : _a.textInput) {
                setDateValue((_b = currentAnswers[index]) === null || _b === void 0 ? void 0 : _b.textInput);
            }
            else if (answer === null || answer === void 0 ? void 0 : answer.textInput) {
                setDateValue(answer === null || answer === void 0 ? void 0 : answer.textInput);
            }
            else {
                setDateValue('1985-01-01');
            }
        }
        else if (matchingAssessment.isKindCourseTime) {
            setTextValue(Course.getDefaultTime(false));
        }
        else {
            // 今回の回答 -> 過去の回答 -> 未回答 の順番で設定する
            if ((_c = currentAnswers[index]) === null || _c === void 0 ? void 0 : _c.textInput) {
                setTextValue((_d = currentAnswers[index]) === null || _d === void 0 ? void 0 : _d.textInput);
            }
            else if (answer === null || answer === void 0 ? void 0 : answer.textInput) {
                setTextValue(answer === null || answer === void 0 ? void 0 : answer.textInput);
            }
            else if (textField.defaultValue) {
                setTextValue(textField.defaultValue);
            }
            else {
                setTextValue('');
            }
        }
    }, [index]);
    useEffect(() => {
        var _a, _b;
        if (currentChoices.length > 0 && ((_a = currentChoices[0]) === null || _a === void 0 ? void 0 : _a.goalDate)) {
            setGoalDate(dayjs.unix(Number(currentChoices[0].goalDate)));
        }
        else {
            setGoalDate(null);
        }
        setDailyGoals((_b = currentChoices[0]) === null || _b === void 0 ? void 0 : _b.dailyGoals);
    }, [currentChoices]);
    const setDefaultCurrentChoices = () => {
        var _a;
        const selectedChoiceList = choices.filter((v) => { var _a; return (_a = currentAnswers[index]) === null || _a === void 0 ? void 0 : _a.choiceIds.includes(v.id); });
        // 今回の回答 -> 過去の回答 -> おすすめ の順番で設定する
        if (selectedChoiceList.length > 0) {
            setCurrentChoices(selectedChoiceList);
        }
        else if ((_a = answer === null || answer === void 0 ? void 0 : answer.choiceIds) === null || _a === void 0 ? void 0 : _a.length) {
            setCurrentChoices(choices.filter((v) => answer.choiceIds.includes(v.id)));
        }
        else if (matchingAssessment.hasDefaultChoice) {
            const defaultChoices = choices.filter((v) => v.isDefaultSelected);
            setCurrentChoices(defaultChoices);
        }
        else {
            const recommendedChoices = choices.filter((v) => v.isRecommended);
            setCurrentChoices(recommendedChoices);
        }
    };
    const onClickChoice = (choice) => {
        let matchingAssessmentChoices = [];
        if (currentChoices.includes(choice)) {
            matchingAssessmentChoices = currentChoices.filter((v) => v.id !== choice.id);
        }
        else {
            // 複数選択できない質問、もしくはクリックした選択肢が unique の場合は choice.id で上書き
            if (!matchingAssessment.isMultiple || choice.selectedUnique) {
                matchingAssessmentChoices = [choice];
            }
            else {
                // クリックした選択肢を追加しつつ unique の選択肢が既に選択されている場合は外す
                const uniqueChoiceIds = currentChoices.filter((v) => v.selectedUnique).map((v) => v.id);
                matchingAssessmentChoices = [...currentChoices.filter((v) => !uniqueChoiceIds.includes(v.id)), choice];
            }
        }
        setCurrentChoices(matchingAssessmentChoices);
    };
    const onChangeTextValue = (e) => {
        const value = e.target.value.trim();
        if (matchingAssessment.isKindUserName && value.length > 15)
            return;
        setTextValue(value);
    };
    const onClickNextButton = () => __awaiter(void 0, void 0, void 0, function* () {
        resetMessage();
        // 目標体重のバリデーション
        if (matchingAssessment.isKindWeightGoal && currentWeight !== Number(textValue)) {
            const isValid = yield checkWeightGoal();
            if (!isValid) {
                return;
            }
        }
        // 入力・選択した値を診断の最後にまとめて送る、かつ質問を戻った時にも初期値として表示するために selectedChoices に保持する
        // また、次の質問で入力内容が残らないように値を空にする
        const choice = {
            matchingAssessmentID: matchingAssessment.id,
            choiceIds: [],
            textInput: '',
        };
        if (isChoiceQuestion) {
            choice.choiceIds = currentChoices.map((choice) => choice.id);
            setCurrentChoices([]);
        }
        else if (textField.isInputTypeDate) {
            if (matchingAssessment.isKindBirthday && !checkDate(dateValue)) {
                return;
            }
            choice.textInput = dateValue;
            setDateValue('');
        }
        else {
            choice.textInput = textValue;
            setTextValue('');
        }
        currentAnswers[index] = choice;
        onClickNext();
    });
    const onClickBackButton = () => {
        resetMessage();
        onClickBack();
    };
    const onClickCopyCurrentWeight = () => {
        setTextValue(currentWeight.toString());
    };
    const checkDate = (v) => {
        const format = 'YYYY-MM-DD';
        if (v && !validateDate(v, format)) {
            setMessageBody(msg.DATE_INVALID);
            return false;
        }
        return true;
    };
    const checkWeightGoal = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield apiClient.checkWeightGoal(currentHeight, currentWeight, textValue).then((v) => {
            if (!v.isValid) {
                setMessageTitle(v.message);
                setMessageBody(v.description);
                return false;
            }
            return true;
        });
        return result;
    });
    const resetMessage = () => {
        setMessageTitle('');
        setMessageBody('');
    };
    return (React.createElement("div", { className: css(styles.container) },
        showProgress && (React.createElement(GoalMatchingAssessmentHeader, { onClickBack: onClickBackButton, prgoressCurrent: progressCurrent, progressQuestionCount: progressQuestionCount, classObject: styles.header })),
        React.createElement("div", { className: css(styles.content, !showProgress && styles.noHeaderContent, matchingAssessment.isKindInterestingLesson && styles.contentForInterestingLesson) },
            React.createElement("div", { className: css(styles.question) },
                React.createElement("div", { className: css(styles.title) }, matchingAssessment.question),
                matchingAssessment.description && (React.createElement("div", { className: css(styles.description) }, matchingAssessment.description))),
            matchingAssessment.isKindWeightGoalPace && (React.createElement("div", { className: css(styles.recommend) },
                React.createElement("span", { className: css(styles.recommendText) }, "\u304A\u3059\u3059\u3081\uFF01"))),
            isChoiceQuestion ? (React.createElement("div", { className: css(styles.choiceContainer, matchingAssessment.isKindCourseDaysOfWeek && styles.choiceContainerLinear, matchingAssessment.isKindInterestingLesson && styles.interestingLessonChoiceContainer, matchingAssessment.isKindMypageProfileField && styles.mypageFieldChoiceContainer) },
                choices.map((choice) => (React.createElement("div", { className: css(styles.button, matchingAssessment.isKindMypageProfileField && styles.mypageFieldChoiceButton, matchingAssessment.showMultiselectChoiceCheckbox && styles.multiselectChoiceButtonWithCheckbox, matchingAssessment.isKindWeightGoalPace && styles.recommendedButton, matchingAssessment.isKindCourseDaysOfWeek && styles.smallCircleButton, matchingAssessment.isKindInterestingLesson && styles.imgButton, choice.isRecommended && styles.recommendedButtonRadius, currentChoices.includes(choice) && styles.selectedButton), onClick: () => onClickChoice(choice), key: choice.id, "data-test": "matchingAssessmentChoice" },
                    matchingAssessment.isKindInterestingLesson && currentChoices.includes(choice) && (React.createElement(CircleCheckPink, { classObject: styles.choiceChecked })),
                    matchingAssessment.showMultiselectChoiceCheckbox && (React.createElement(React.Fragment, null, currentChoices.includes(choice) ? (React.createElement(CheckIcon, { color: Colors.White, classObject: [
                            styles.multiselectChoiceCheckboxIcon,
                            styles.multiselectChoiceCheckboxIconChecked,
                        ] })) : (React.createElement(CheckIcon, { color: Colors.White, classObject: styles.multiselectChoiceCheckboxIcon })))),
                    choice.iconSrc && (React.createElement("img", { className: css(styles.choiceImg, matchingAssessment.isKindInterestingLesson && styles.fullImg), src: choice.iconImageURL })),
                    (choice.choices || choice.description) && (React.createElement("div", { className: css(styles.choiceText, matchingAssessment.isKindMypageProfileField && styles.mypageFieldChoiceText) },
                        React.createElement("div", { className: css(styles.choiceName, matchingAssessment.isKindMypageProfileField && styles.mypageFieldChoiceName) }, choice.choices),
                        choice.description && React.createElement("div", { className: css(styles.choiceDescription) }, choice.description)))))),
                goalDate && (React.createElement("div", { className: css(styles.goalDate) },
                    React.createElement(CalendarSolidIcon, null),
                    React.createElement("div", { className: css(styles.goalDateText) },
                        React.createElement("div", { className: css(styles.dateNumber) }, goalDate.year()),
                        "\u5E74",
                        React.createElement("div", { className: css(styles.dateNumber) }, goalDate.month() + 1),
                        "\u6708",
                        React.createElement("div", { className: css(styles.dateNumber) }, goalDate.date()),
                        "\u65E5\u306B\u9054\u6210"))),
                (dailyGoals === null || dailyGoals === void 0 ? void 0 : dailyGoals.length) > 0 && React.createElement(GoalMatchingAssessmentFormDailyGoals, { config: config, dailyGoals: dailyGoals }))) : (React.createElement(React.Fragment, null, textField && (React.createElement(React.Fragment, null, textField.isInputTypeText ? (React.createElement(InputWithoutOutline, { type: textField.inputType, placeholder: textField.placeholder, unitLabel: textField.unit, onChange: onChangeTextValue, value: textValue })) : textField.isInputTypeDate ? (React.createElement("div", { className: css(styles.inputDate) },
                React.createElement(DateSelectFormWithoutOutline, { currentValue: dateValue, setCurrentValue: setDateValue }))) : textField.isInputTypeTime ? (React.createElement("div", { className: css(styles.inputTime) },
                React.createElement(TimeSelectForm, { label: "", currentValue: textValue, setCurrentValue: setTextValue, selectClassObject: styles.timeSelect, listClassObject: styles.timeSelectList, listItemClassObject: styles.timeSelectListItem, displayIcon: false, format: TimeSelectFormat.hmm }),
                React.createElement(CourseTimeInfo, { time: textValue }))) : (textField.isInputTypeNumber && (React.createElement(React.Fragment, null, matchingAssessment.isKindWeightGoal ? (React.createElement("div", { className: css(styles.weightGoal) },
                React.createElement("div", { className: css(styles.currentWeight) },
                    React.createElement("div", { className: css(styles.currentWeightNumber) }, currentWeight),
                    React.createElement("div", { className: css(styles.currentWeightUnit) }, "kg")),
                React.createElement(ArrowIcon, { classObject: styles.weightArrowIcon, direction: ArrowDirection.right, color: Colors.BackgroundGrayD }),
                React.createElement(InputWithoutOutline, { classObject: styles.inputWeightGoal, type: textField.inputType, placeholder: textField.placeholder, unitLabel: textField.unit, onChange: onChangeTextValue, value: textValue }))) : (React.createElement(InputWithoutOutline, { type: textField.inputType, placeholder: textField.placeholder, unitLabel: textField.unit, onChange: onChangeTextValue, value: textValue })))))))))),
        (messageTitle || messageBody) && (React.createElement(GoalMatchingAssessmentFormMessage, { isInputTypeDate: textField === null || textField === void 0 ? void 0 : textField.isInputTypeDate, messageTitle: messageTitle, messageBody: messageBody })),
        React.createElement(GoalMatchingAssessmentFormFooter, { isKindWeightGoal: matchingAssessment.isKindWeightGoal, isKindInterestingLesson: matchingAssessment.isKindInterestingLesson, isDisabled: isDisabled, onClickNext: onClickNextButton, onClickCopyCurrentWeight: onClickCopyCurrentWeight })));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    header: {},
    content: {
        width: '100%',
        [MediaBreakPointUp.MD]: {
            width: 303,
            paddingBottom: 120,
            margin: 'auto',
            paddingTop: 90,
        },
    },
    noHeaderContent: {
        [MediaBreakPointUp.MD]: {
            paddingTop: 166,
        },
    },
    contentForInterestingLesson: {
        width: 332,
        [MediaBreakPointUp.MD]: {
            width: 668,
        },
    },
    question: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        gap: 18,
        marginBottom: 40,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.6,
    },
    description: {
        color: Colors.GrayDarkest,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '140%',
        letterSpacing: 0.56,
    },
    weightGoal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 13,
    },
    currentWeight: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        lineHeight: '140%',
        height: 28,
    },
    currentWeightNumber: {
        fontSize: 20,
        letterSpacing: 1.6,
    },
    currentWeightUnit: {
        fontSize: 14,
        letterSpacing: 1.12,
    },
    weightArrowIcon: {
        width: 22,
        height: 22,
    },
    inputWeightGoal: {
        marginRight: 35,
    },
    inputDate: {
        display: 'flex',
        justifyContent: 'center',
        gap: 40,
    },
    inputTime: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 40,
        [MediaBreakPointUp.MD]: {
            gap: 80,
        },
    },
    choiceContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: 8,
    },
    choiceContainerLinear: {
        flexWrap: 'nowrap',
        gap: 'auto',
        maxWidth: 327,
        margin: '0 auto',
    },
    interestingLessonChoiceContainer: {
        gap: 4,
    },
    choiceChecked: {
        position: 'absolute',
        top: 8,
        right: 8,
    },
    recommend: {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'relative',
        bottom: -2,
    },
    recommendText: {
        color: Colors.White,
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '100%',
        borderRadius: '8px 8px 0 0',
        padding: '5px 8px',
        display: 'inline-block',
        marginLeft: 'auto',
        background: Colors.PrimaryDark,
    },
    choiceImg: {
        width: 40,
        height: 40,
    },
    fullImg: {
        width: '100%',
        height: '100%',
        borderRadius: 10,
    },
    choiceText: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    choiceName: {
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: 0.56,
        minHeight: 20,
        whiteSpace: 'pre-wrap',
    },
    button: {
        position: 'relative',
        padding: '16px 24px',
        gap: 16,
        borderRadius: 14,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: Colors.White,
        border: `1px ${Colors.Gray} solid`,
        cursor: 'pointer',
        width: '100%',
        minHeight: 68,
    },
    smallCircleButton: {
        width: 40,
        minHeight: 40,
        borderRadius: '50%',
        padding: 0,
    },
    mypageFieldChoiceContainer: {
        flexDirection: 'column',
        gap: 10,
        boxSizing: 'border-box',
        maxWidth: 327,
        width: '100%',
        margin: '0 auto',
    },
    mypageFieldChoiceButton: {
        width: '100%',
        minHeight: 62,
    },
    multiselectChoiceButtonWithCheckbox: {
        justifyContent: 'flex-start',
        gap: 12,
    },
    mypageFieldChoiceText: {
        flex: 1,
        minWidth: 0,
    },
    mypageFieldChoiceName: {
        textAlign: 'left',
    },
    multiselectChoiceCheckboxIcon: {
        width: 20,
        height: 20,
        borderRadius: 6,
        backgroundColor: Colors.GrayLighter,
    },
    multiselectChoiceCheckboxIconChecked: {
        backgroundColor: Colors.PrimaryDark,
    },
    recommendedButton: {
        gap: 8,
    },
    recommendedButtonRadius: {
        borderRadius: '14px 0 14px 14px',
    },
    selectedButton: {
        backgroundColor: Colors.PrimaryLighter,
        border: `2px ${Colors.PrimaryDark} solid`,
    },
    imgButton: {
        width: 164,
        height: 94,
        minHeight: 90,
        padding: 0,
        border: `2px ${Colors.White} solid`,
    },
    choiceDescription: {
        fontSize: 12,
        fontWeight: 400,
        color: Colors.GrayDarkest,
    },
    goalDate: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: Colors.Black,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 0.56,
        width: '100%',
        height: 28,
        gap: 8,
        marginTop: 16,
    },
    goalDateText: {
        display: 'flex',
        alignItems: 'flex-end',
        height: '100%',
    },
    dateNumber: {
        fontSize: 20,
        letterSpacing: 0.8,
        marginBottom: 2,
    },
    timeSelect: {
        border: 0,
        borderRadius: 0,
        borderBottom: `2px solid ${Colors.BorderLightGray}`,
        height: 45,
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '140%',
        letterSpacing: 2.56,
        textAlign: 'center',
        ':focus': {
            boxShadow: 'none',
        },
    },
    timeSelectList: {
        height: 429,
        minWidth: 81,
    },
    timeSelectListItem: {
        fontSize: 12,
        minHeight: 33,
        height: 33,
        justifyContent: 'center',
    },
});
